import { render } from "./partial-payments.vue?vue&type=template&id=3bd1c707"
import script from "./partial-payments.vue?vue&type=script&lang=js"
export * from "./partial-payments.vue?vue&type=script&lang=js"

import "./partial-payments.vue?vue&type=style&index=0&id=3bd1c707&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__